module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("\n    Configure the settings for your device.\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendDone($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "friendly_name"
    }
  }, [_vm._v("Friendly name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "My awesome device name",
      "id": "friendly_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "device_id"
    }
  }, [_vm._v("Device ID")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceId),
      expression: "deviceId",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "pattern": "^(([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9]))$",
      "placeholder": "the-device-id",
      "id": "device_id"
    },
    domProps: {
      "value": (_vm.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceId = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox",
    attrs: {
      "for": "ota"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ota),
      expression: "ota"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ota"
    },
    domProps: {
      "checked": Array.isArray(_vm.ota) ? _vm._i(_vm.ota, null) > -1 : (_vm.ota)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ota,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.ota = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ota = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ota = $$c
        }
      }
    }
  }), _vm._v(" Enable OTA\n      ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.deviceInformation.settings.length === 0) ? _c('p', [_vm._v("No custom settings.")]) : [_c('p'), _c('h3', [_vm._v("Custom settings")]), _vm._v(" "), _vm._l((_vm.deviceInformation.settings), function(setting) {
    return [(setting.type === 'bool') ? [_c('p', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "checkbox",
      attrs: {
        "for": 'custom_setting_' + setting.name
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "checked": Array.isArray(_vm.customSettings[setting.name]) ? _vm._i(_vm.customSettings[setting.name], null) > -1 : (_vm.customSettings[setting.name])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.customSettings[setting.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.customSettings[setting.name] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.customSettings[setting.name] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            var $$exp = _vm.customSettings,
              $$idx = setting.name;
            if (!Array.isArray($$exp)) {
              _vm.customSettings[setting.name] = $$c
            } else {
              $$exp.splice($$idx, 1, $$c)
            }
          }
        }
      }
    }), _vm._v(" " + _vm._s(setting.description) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "help",
      domProps: {
        "innerHTML": _vm._s(setting.required ? 'Required.' : 'Optional. Defaults to <span class=\'tag\'>' + setting.default+'</span>.')
      }
    })])] : [_c('label', {
      staticClass: "label",
      attrs: {
        "for": 'custom_setting_' + setting.name
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: {
        fa: true, 'fa-hashtag': setting.type === 'long' || setting.type === 'ulong' || setting.type === 'double', 'fa-font': setting.type === 'string'
      }
    })]), _vm._v(" " + _vm._s(setting.type === 'double' ? '(float)' : '') + " " + _vm._s(setting.type === 'ulong' ? '(unsigned)' : '') + " " + _vm._s(setting.description))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [(setting.type === 'ulong') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "4294967295",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (setting.type === 'long') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "-2147483648",
        "max": "2147483647",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (setting.type === 'double') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "step": "any",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (setting.type === 'string') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = $event.target.value.trim()
          } else {
            $$exp.splice($$idx, 1, $event.target.value.trim())
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "help",
      domProps: {
        "innerHTML": _vm._s(setting.required ? 'Required.' : 'Optional. Defaults to <span class=\'tag\'>' + setting.default+'</span>.')
      }
    })])]]
  }), _vm._v(" "), _c('p')], _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Next")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help"
  }, [_vm._v("Optional. The default value is the hardware device ID. MAY be composed of lowercase letters from "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("a")]), _vm._v(" to "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("z")]), _vm._v(", numbers from "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("0")]), _vm._v(" to "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("9")]), _vm._v(", and it MAY contain "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("-")]), _vm._v(", but MUST NOT start or end with a "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("-")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee3761a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Settings.vue
// module id = 58
// module chunks = 0